import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DuplicateDripSequence as DuplicateDripSequenceMutation,
    DuplicateDripSequenceVariables,
} from 'nutshell-graphql-types';

import {dripSequenceDeleteRestoreUpdate} from '../../helpers';

import DUPLICATE_DRIP_SEQUENCE from '../mutations/duplicate-sms-drip-sequence.graphql';

export function useDuplicateSmsDripSequence(): {
    duplicateDripSequence: (name: string, dripSequenceId: string) => Promise<any>;
    error: string | null | undefined;
} {
    const [duplicateDripSequence, {loading, error}] = useMutation<
        DuplicateDripSequenceMutation,
        DuplicateDripSequenceVariables
    >(DUPLICATE_DRIP_SEQUENCE);

    return {
        duplicateDripSequence: (name: string, dripSequenceId: string) =>
            duplicateDripSequence({
                variables: {input: {name, campaignId: dripSequenceId}},
                update: (proxy, mutationResults) => {
                    // Get the new dripSequence
                    const newDripSequence =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.dripSequenceDuplicate &&
                        mutationResults.data.dripSequenceDuplicate.dripSequence;

                    if (!newDripSequence) return;

                    // @ts-expect-error
                    dripSequenceDeleteRestoreUpdate(proxy, newDripSequence, false);
                },
            }),
        // @ts-expect-error
        isDeleting: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
